import { FC } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import './index.less'

interface Props {
  text: string
  // onChange can be optional -> RichTextBox is also used for displaying readonly formated Text
  onChange?: (text: string) => void
  onBlur?: () => Promise<void>
  readonly?: boolean
  isInTablerow?: boolean
  placeholder?: string
}

const RichTextBox: FC<Props> = ({ text, onChange, onBlur, readonly = false, isInTablerow = false, placeholder }) => {
  return (
    <ReactQuill
      placeholder={placeholder}
      value={text}
      onChange={readonly ? undefined : onChange}
      onBlur={readonly ? undefined : onBlur}
      readOnly={readonly}
      theme={readonly ? 'bubble' : 'snow'}
      className={`${readonly ? 'readonly' : 'editable'} ${isInTablerow && 'isInTablerow'}`}
    />
  )
}

export default RichTextBox
